import { render } from "./Textfield.vue?vue&type=template&id=c622fffe"
import script from "./Textfield.vue?vue&type=script&lang=js"
export * from "./Textfield.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__